import SectionWrapperStyles from '@stories/Components/SectionWrapper/SectionWrapper.styles';
import { ImageCarouselStyles } from '@stories/Widgets/ImageCarousel/ImageCarousel.styles';
import styled from 'styled-components';
const Container = styled.div `
  ${() => ImageCarouselStyles.Container} {
    padding: 0;

    ${() => SectionWrapperStyles.Inner} {
      padding: 0;
    }
  }
`;
export const ImageCarouselBlockStyles = {
    Container,
};
